import React from 'react'


class TabsBlockProFile extends React.PureComponent {

	mapDetail = (detail) =>{
	}
	
	render() {
		const { detail } = this.props
		return (
			<>
				
			</>
		)
	}
}

export default TabsBlockProFile